import React from 'react';
import { CpuIcon } from 'lucide-react';
import { AgentMark } from '../ui/AgentMark';
import type { AgentId } from '../../types/anna';

/** AgentMark that also covers system rows. */
export function ActorMark({
  actor,
  size = 'md'
}: {
  actor: AgentId | 'systeem';
  size?: 'sm' | 'md';
}) {
  if (actor !== 'systeem') return <AgentMark agentId={actor} size={size} data-id="element-29" data-mp="1ih5eyvaubbdz" />;
  return <span className={`grid shrink-0 place-items-center rounded-full bg-white/[0.06] text-ink-muted ring-1 ring-inset ring-white/10 ${size === 'sm' ? 'h-6 w-6' : 'h-8 w-8'}`} aria-hidden data-id="element-30" data-mp="uqhsn506gj7w">
      <CpuIcon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} strokeWidth={1.75} data-id="element-31" data-mp="14g1bianw4d2r" />
    </span>;
}